/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.social.init());

App.social = { 
  init() {
    return $(document)
      .off("click", ".js-share-fb", App.social.share_fb)
      .on("click", ".js-share-fb", App.social.share_fb);
  },

  share_fb(evt) {
    evt.preventDefault();
    return FB.ui({
      method: "feed",
      link: $(this).attr("href"),
      description: $(this).attr("description"),
    });
  }
};
